import { z } from 'zod'
import { DASHBOARD_PLUGIN_KEYS } from '../../enums/dashboard-plugin-key.enum'
import { dashboardPluginSizeSchema } from './dashboard-plugin-size.schema'

export const createDashboardPluginSchema = z.object({
  pluginKey: z.enum(DASHBOARD_PLUGIN_KEYS),
  size: dashboardPluginSizeSchema.optional().default('medium'),
  config: z.record(z.string(), z.unknown()).optional().default({}),
  order: z.number().int().min(0).optional(),
})
export type CreateDashboardPluginDto = z.infer<typeof createDashboardPluginSchema>
